import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { BannerComponent } from '../../../../shared/components/banner/banner.component';
import { filter, takeUntil } from 'rxjs/operators';
import { Country } from '../../../../core/interfaces/doctor.interface';
import { CountryStorageService } from '../../../../core/services/country.storage.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-profil-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, BannerComponent],
  templateUrl: './profil-layout.component.html',
  styleUrls: ['./profil-layout.component.scss'],
})
export class ProfilLayoutComponent implements OnInit, OnDestroy {
  isDppTheme = environment.theme.default === 'dpp';
  selectedCountry: Country | null = null;
  private destroy$ = new Subject<void>();

  // Onglets disponibles
  tabs = [
    {
      id: 'general-info',
      label: 'Informations générales',
      route: 'profil/general-info',
    },
    {
      id: 'change-password',
      label: 'Mot de passe',
      route: 'profil/change-password',
    },
    { id: 'activities', label: 'Mon activité', route: 'profil/activities' },
    {
      id: 'managed-accounts',
      label: 'Mes comptes gérés',
      route: 'profil/managed-accounts',
    },
    {
      id: 'preferences',
      label: "Préférences",
      route: 'profil/preferences',
    }
  ];

  selectedTab: string = 'general-info';

  constructor(
    private router: Router,
    private countryStorage: CountryStorageService
  ) {}

  ngOnInit() {
    this.countryStorage.country$
      .pipe(takeUntil(this.destroy$))
      .subscribe((country) => {
        this.selectedCountry = country;
      });

    // Déterminer l'onglet actif basé sur la route actuelle
    this.updateSelectedTab(this.router.url);

    // Écouter les changements de route
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((event: any) => {
        this.updateSelectedTab(event.urlAfterRedirects || event.url);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateSelectedTab(url: string) {
    if (url.includes('/profil/general-info')) {
      this.selectedTab = 'general-info';
    } else if (url.includes('/profil/change-password')) {
      this.selectedTab = 'change-password';
    } else if (url.includes('/profil/activities')) {
      this.selectedTab = 'activities';
    } else if (url.includes('/profil/managed-accounts')) {
      this.selectedTab = 'managed-accounts';
    } else {
      // Par défaut, rediriger vers general-info
      this.selectedTab = 'general-info';
      if (
        url === '/profil' ||
        url === `/${this.selectedCountry?.code}/profil`
      ) {
        this.router.navigate([
          `/${this.selectedCountry?.code}/profil/general-info`,
        ]);
      }
    }
  }

  onTabChange(tabId: string) {
    this.selectedTab = tabId;
    const tab = this.tabs.find((t) => t.id === tabId);
    if (tab && this.selectedCountry?.code) {
      this.router.navigate([
        `/${this.selectedCountry.code.toLowerCase()}/${tab.route}`,
      ]);
    }
  }

  isTabActive(tabId: string): boolean {
    return this.selectedTab === tabId;
  }
}
